module.exports = __webpack_public_path__ + "static/img/avatar.5a2da957.png";